import './Counselor.css'
import { Container, Row, Col, Card} from 'react-bootstrap'
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
export default function Counselor() {
    return (
        <div className="counselorPageSection">            <Container>
                <Row>
                    <Col md={12} className="text-center mb-3">
                        <div className="sectionTitle">
                            <h2>Our Counselor Member</h2>
                            <p>Lorem ipsum dolorsit amet consecte turadip isior ipsum dolor sit ametor ipsum dolor sit amet conse</p>
                        </div>
                    </Col>
                </Row>
                <Row className="mb-5">
                    <Col className="mb-3 text-center" md={3}>
                        <Card>
                            <Card.Img className="counselorImg" variant="top" src="https://images.pexels.com/photos/1300402/pexels-photo-1300402.jpeg" />
                            <Card.Body>
                                <Card.Title>MERI ANDERSON</Card.Title>
                                <Card.Text>
                                Some quick example text to build on the card title.
                                </Card.Text>
                                <div className="socialMedia">
                                    <ul className="socialMediaItems">
                                        <li className="SMItem"><FaFacebookF/></li>
                                        <li className="SMItem"><FaTwitter/></li>
                                        <li className="SMItem"><FaLinkedinIn/></li>
                                        <li className="SMItem"><FaInstagram/></li>
                                    </ul>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col className="mb-3 text-center" md={3}>
                        <Card>
                            <Card.Img className="counselorImg" variant="top" src="https://images.pexels.com/photos/1121796/pexels-photo-1121796.jpeg" />
                            <Card.Body>
                                <Card.Title>MERI ANDERSON</Card.Title>
                                <Card.Text>
                                Some quick example text to build on the card title.
                                </Card.Text>
                                <div className="socialMedia">
                                    <ul className="socialMediaItems">
                                        <li className="SMItem"><FaFacebookF/></li>
                                        <li className="SMItem"><FaTwitter/></li>
                                        <li className="SMItem"><FaLinkedinIn/></li>
                                        <li className="SMItem"><FaInstagram/></li>
                                    </ul>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col className="mb-3 text-center" md={3}>
                        <Card>
                            <Card.Img className="counselorImg" variant="top" src="https://images.pexels.com/photos/874158/pexels-photo-874158.jpeg" />
                            <Card.Body>
                                <Card.Title>MERI ANDERSON</Card.Title>
                                <Card.Text>
                                Some quick example text to build on the card title.
                                </Card.Text>
                                <div className="socialMedia">
                                    <ul className="socialMediaItems">
                                        <li className="SMItem"><FaFacebookF/></li>
                                        <li className="SMItem"><FaTwitter/></li>
                                        <li className="SMItem"><FaLinkedinIn/></li>
                                        <li className="SMItem"><FaInstagram/></li>
                                    </ul>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col className="mb-3 text-center" md={3}>
                        <Card>
                            <Card.Img className="counselorImg" variant="top" src="https://images.pexels.com/photos/1680172/pexels-photo-1680172.jpeg" />
                            <Card.Body>
                                <Card.Title>MERI ANDERSON</Card.Title>
                                <Card.Text>
                                Some quick example text to build on the card title.
                                </Card.Text>
                                <div className="socialMedia">
                                    <ul className="socialMediaItems">
                                        <li className="SMItem"><FaFacebookF/></li>
                                        <li className="SMItem"><FaTwitter/></li>
                                        <li className="SMItem"><FaLinkedinIn/></li>
                                        <li className="SMItem"><FaInstagram/></li>
                                    </ul>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col className="mb-3 text-center" md={3}>
                        <Card>
                            <Card.Img className="counselorImg" variant="top" src="https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg"/>
                            <Card.Body>
                                <Card.Title>MERI ANDERSON</Card.Title>
                                <Card.Text>
                                Some quick example text to build on the card title.
                                </Card.Text>
                                <div className="socialMedia">
                                    <ul className="socialMediaItems">
                                        <li className="SMItem"><FaFacebookF/></li>
                                        <li className="SMItem"><FaTwitter/></li>
                                        <li className="SMItem"><FaLinkedinIn/></li>
                                        <li className="SMItem"><FaInstagram/></li>
                                    </ul>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col className="mb-3 text-center" md={3}>
                        <Card>
                            <Card.Img className="counselorImg" variant="top" src="https://images.pexels.com/photos/6327577/pexels-photo-6327577.jpeg" />
                            <Card.Body>
                                <Card.Title>MERI ANDERSON</Card.Title>
                                <Card.Text>
                                Some quick example text to build on the card title.
                                </Card.Text>
                                <div className="socialMedia">
                                    <ul className="socialMediaItems">
                                        <li className="SMItem"><FaFacebookF/></li>
                                        <li className="SMItem"><FaTwitter/></li>
                                        <li className="SMItem"><FaLinkedinIn/></li>
                                        <li className="SMItem"><FaInstagram/></li>
                                    </ul>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col className="mb-3 text-center" md={3}>
                        <Card>
                            <Card.Img className="counselorImg" variant="top" src="https://images.pexels.com/photos/1300402/pexels-photo-1300402.jpeg" />
                            <Card.Body>
                                <Card.Title>MERI ANDERSON</Card.Title>
                                <Card.Text>
                                Some quick example text to build on the card title.
                                </Card.Text>
                                <div className="socialMedia">
                                    <ul className="socialMediaItems">
                                        <li className="SMItem"><FaFacebookF/></li>
                                        <li className="SMItem"><FaTwitter/></li>
                                        <li className="SMItem"><FaLinkedinIn/></li>
                                        <li className="SMItem"><FaInstagram/></li>
                                    </ul>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col className="mb-3 text-center" md={3}>
                        <Card>
                            <Card.Img className="counselorImg" variant="top" src="https://images.pexels.com/photos/842811/pexels-photo-842811.jpeg" />
                            <Card.Body>
                                <Card.Title>MERI ANDERSON</Card.Title>
                                <Card.Text>
                                Some quick example text to build on the card title.
                                </Card.Text>
                                <div className="socialMedia">
                                    <ul className="socialMediaItems">
                                        <li className="SMItem"><FaFacebookF/></li>
                                        <li className="SMItem"><FaTwitter/></li>
                                        <li className="SMItem"><FaLinkedinIn/></li>
                                        <li className="SMItem"><FaInstagram/></li>
                                    </ul>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
